module.exports = __webpack_public_path__ + "static/toggle-119509ffcbc27cc52c68f3ce588123da.mp4";